import Index from 'components/notifications/Index';

const Notifications = () => {
	return <Index />;
};

export default Notifications;
